const populatedActions = {};

const syncActions = [
  'CLEAR_FORM',

  'EVENTS_ORDER_CREATED',
  'CLEAR_ORDER_VALIDATION',

  'TRACK_EVENT',
  'TRACK_CHANGE_PAYMENT',

  'CLEAR_STATEMENTS',
];

for (const action of syncActions) {
  populatedActions[action] = action;
}

export default populatedActions;
